/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import uploadIcon from "../img/upload.svg";

function ReqFooter() {
  useEffect(() => {
    console.log("localStorage:", localStorage);
  }, []);

  const handleShare = async () => {
    const requisites = JSON.parse(localStorage.getItem("bioData"));

    if (requisites && requisites.fio && requisites.iin && requisites.birth && requisites.docnum && requisites.viddata && requisites.expdata) {
      try {
        const text = `
          Удостоверение личности:
          ФИО: ${requisites.fio}
          ИИН: ${requisites.iin}
          Дата рождения: ${requisites.birth}
          Номер документа: ${requisites.docnum}
          Дата выдачи: ${requisites.viddata}
          Срок действия: ${requisites.expdata}
        `;

        // Проверяем поддержку API share
        if (navigator.share) {
          try {
            console.log("Попытка поделиться через navigator.share...");
            await navigator.share({
              title: "Поделиться реквизитами",
              text: text, 
            });
            console.log("Успешно поделились!");
          } catch (error) {
            console.error("Ошибка при попытке поделиться через navigator.share:", error);
          }
        } else {
          navigator.clipboard.writeText(text)
            .then(() => {
              console.log("Реквизиты скопированы в буфер обмена.");
            })
            .catch((error) => {
              console.error("Ошибка при копировании в буфер обмена:", error);
            });
        }
      } catch (error) {
        console.error("Ошибка при формировании текста для отправки:", error);
      }
    } else {
      console.error("Нет данных для отправки.");
    }
  };

  return (
    <div className="footer">
      <div className="btnfooter" id="docbtn">
        <button id="btnftr2" className="share" onClick={handleShare}>
          <img src={uploadIcon} alt="Upload Icon" />
          Поделиться реквизитами
        </button>
      </div>
    </div>
  );
}

export default ReqFooter;
